import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import browserRoute from "../../Routes/browserRoutes";
import Images from "../Helper/AllImages";
import data from "../Helper/Data/LiquidityProvider_Funds";
import { AddLiquidity } from "../PopModals/AddLiquidity_Modal";
import TableBody from "./TableBody";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "@mui/material/Pagination";
import { totalLiquidity_Providing } from "../../Services/mainServices";

const LiquidityProvider = () => {
  const dispatch = useDispatch();
  const mainInstance = useSelector((state) => state.main);
  const liquidityData = useSelector((state) => state.main.liquidityAdded);
  const [tableData, setTableData] = useState([]);
  const [keyState, setKeyState] = useState("");
  const [closeAll, setCloseAll] = useState(false);
  const [overallBalance_BTC, setOverallBalance_BTC] = useState(0);
  const [overallBalance_USD, setOverallBalance_USD] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [cardsPerPage, setCardsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const countData = tableData?.length;
  const [poolBalance, setPoolBalance] = useState("");
  const [totalPoolBalance, setTotalPoolBalance] = useState(0);

  useEffect(() => {
    if (liquidityData) {
      setTableData([...liquidityData]);
    }
  }, [liquidityData]);
  // useEffect(() => {
  //   setTableData(data);
  // }, []);

  useEffect(() => {
    setTotalPoolBalance(totalPoolBalance + Number(poolBalance));
  }, [poolBalance]);

  useEffect(() => {
    dispatch(totalLiquidity_Providing(totalPoolBalance));
  }, [totalPoolBalance]);

  useEffect(() => {
    if (countData % cardsPerPage === 0) {
      setCount(Math.floor(countData / cardsPerPage));
    } else {
      setCount(Math.floor(countData / cardsPerPage) + 1);
    }
  }, [countData, cardsPerPage]);

  const myRef = useRef(null);

  const handleChange = (event, value) => {
    // window.scrollTo(0, 0);
    myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    setPage(value);
  };

  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  useEffect(() => {
    setOverallBalance_BTC(mainInstance.overallBalance_BTC);
    setOverallBalance_USD(mainInstance.overallBalance_USD);
  }, [mainInstance.KeyStoreClient, mainInstance]);

  const searchInputHandler = (e) => {
    setSearchInput(e.target.value);
    if (!e.target.value) {
      setTableData(data);
    } else {
      let res = data?.filter(
        (value) =>
          value.Pool.toLowerCase().includes(e.target.value.toLowerCase()) &&
          value
      );
      setTableData(res);
    }
  };

  return (
    <div
      class="col-lg-10 n-liquidityMainArea"
      //  style={{ paddingRight: "8px" }} pl-0
    >
      <div class="w-sidebarcoleight">
        <h4 className="u-overview09888">Liquidity providing </h4>
        <div class="d-flex justify-content-between flex-column flex-sm-row">
          <div>
            <p className="w-over-text">Total balance in pools</p>
            <div class="d-flex">
              <p className="u-mainclassliquidity6788">
                {/* {overallBalance_USD ? (
                  <>{numberWithCommas(financial(overallBalance_USD))}</>
                ) : (
                  0
                )} */}
                ${totalPoolBalance}
              </p>
              {/* <p
                style={{
                  backgroundColor: "#58BD7D",
                  fontSize: "12px",
                  padding: "8px 8px 6px 8px",
                  fontFamily: "Poppins",
                  color: "#fff",
                  position: "relative",
                  fontWeight: "700",
                  marginLeft: "8px",
                  borderRadius: "5px",
                  marginBottom: "0px",
                }}
              >
                BTC
              </p> */}
            </div>
            {/* <p
              class="mt-4"
              style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                position: "relative",
                top: "-10px",
                color: "#777E90",
                marginBottom: "0px",
              }}
            >
              $
              {overallBalance_USD ? (
                <>{numberWithCommas(financial(overallBalance_USD))}</>
              ) : (
                0
              )}
            </p> */}
          </div>
          <div class="">
            <p
              style={{
                margin: "0px",
                fontSize: "16px",
                fontFamily: "Poppins",
                fontWeight: "400",
                color: "#777E90",
                lineHeight: "24px",
                paddingBottom: "4px",
              }}
            >
              Current estimated APY
            </p>
            <p className="u-mainclassliquidity6788">
              {mainInstance.isLoggedin ? 0 : 0}{" "}
              <span
                style={{
                  backgroundColor: "#58BD7D",
                  fontSize: "12px",
                  padding: "5px",
                  fontFamily: "Poppins",
                  color: "#fff",
                  position: "relative",
                  top: "-4px",
                  paddingLeft: "10px",
                  fontWeight: "700",
                  marginLeft: "8px",
                  paddingRight: "8px",
                  borderRadius: "5px",
                }}
              >
                BTC
              </span>
            </p>
          </div>
        </div>
      </div>
      <p className="w-over-center-heading">Funds</p>
      <div class="w-sidebarcoleight">
        <div class="d-flex justify-content-between flex-wrap">
          <div className="n-liquiditySearch">
            <div class=" d-flex form-group has-search">
              <input
                // style={{
                //   borderRadius: "25px",
                //   width: "250px",
                //   paddingTop: "15px",
                //   paddingBottom: "15px",
                //   fontFamily: "DM Sans",
                // }}
                value={searchInput}
                onChange={searchInputHandler}
                type="text"
                class="form-control n-tableSearch n-tableSeachDark"
                placeholder="Search"
                aria-label="Search"
              />
              {/* <img
              class="n-liquiditySearchIcon"
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "-35px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                src={Images.searchicon}
              /> */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  marginLeft: "-35px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.4207 13.5992C11.2918 14.4768 9.87327 14.9993 8.33268 14.9993C4.65078 14.9993 1.66602 12.0146 1.66602 8.33268C1.66602 4.65078 4.65078 1.66602 8.33268 1.66602C12.0146 1.66602 14.9993 4.65078 14.9993 8.33268C14.9993 9.87327 14.4768 11.2918 13.5992 12.4207L18.0886 16.9101C18.414 17.2355 18.414 17.7632 18.0886 18.0886C17.7632 18.414 17.2355 18.414 16.9101 18.0886L12.4207 13.5992ZM13.3327 8.33268C13.3327 11.0941 11.0941 13.3327 8.33268 13.3327C5.57126 13.3327 3.33268 11.0941 3.33268 8.33268C3.33268 5.57126 5.57126 3.33268 8.33268 3.33268C11.0941 3.33268 13.3327 5.57126 13.3327 8.33268Z"
                  fill="#777E91"
                />
              </svg>
            </div>
          </div>
          {/* <input
            style={{ width: "25%", borderRadius: "20px" }}
            class="form-control mr-sm-2"
            type="text"
            placeholder="Search"
            aria-label="Search"
          /> */}
          <p class="trans-history" style={{ color: "#777E90" }}>
            <Link
              to={browserRoute.PORTFOLIO_ACTIVITY}
              style={{
                // color: "rgb(119, 126, 144)",
                textDecoration: "none",
                fontSize: "12px",
                fontWeight: "600",
                fontFamily: "Poppins",
              }}
              className="n-transcationHistory"
            >
              Transaction History
              <i
                className="fa fa-chevron-right ml-2 pt-1"
                style={{ fontSize: "10px" }}
              ></i>
            </Link>
          </p>
        </div>
        <div id="starred" class="mt-3 pb-1 w-portfoilo-tb">
          <div class="table-responsive w-comon-table-style" ref={myRef}>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Pools</th>
                  <th className="text-right" scope="col">
                    Yield rate
                  </th>
                  <th className="text-right" scope="col">
                    Total balance
                  </th>
                  <th className="text-right" scope="col">
                    Available balance
                  </th>
                  <th
                    className="text-right"
                    scope="col"
                    class="d-flex justify-content-end"
                  >
                    P/L
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.length ? (
                  tableData
                    ?.slice(
                      page * cardsPerPage - cardsPerPage,
                      cardsPerPage * page
                    )
                    ?.map((d, key) => {
                      return (
                        <TableBody
                          d={d}
                          key={key}
                          Key={key}
                          setKeyState={setKeyState}
                          keyState={keyState}
                          closeAll={closeAll}
                          setCloseAll={setCloseAll}
                          setPoolBalance={setPoolBalance}
                        />
                      );
                    })
                ) : (
                  <tr>
                    <td
                      colspan="6"
                      class="text-center text-muted"
                      style={{ padding: "148px 0px" }}
                    >
                      <div className="w-no-data-tb">
                        No Liquidity providing Found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="paging-center">
              {tableData?.length ? (
                <Pagination count={count} page={page} onChange={handleChange} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiquidityProvider;
